import React, { useState } from 'react';
import { Card, Modal, Button } from 'antd';
import Plot from 'react-plotly.js';
import { FullscreenOutlined } from '@ant-design/icons';

const ChartComponent = ({ data, title, layout }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Apply hex color styles directly and adjust marker size
  const updatedData = data.flatMap((trace, index) => {
    let color;
    switch (index) {
      case 0:
        color = '#003f5c';
        break;
      case 1:
        color = '#bc5090';
        break;
      case 2:
        color = '#ffa600';
        break;
      default:
        color = trace.marker?.color || '#000';
    }

    // Assume trace.high and trace.low contain the high/low prices for each day
    const { high, low, ...baseTrace } = trace;

    // Base trace for the line
    const mainTrace = {
      ...baseTrace,
      line: { ...trace.line, color: color },
      marker: { ...trace.marker, color: color, size: 4 },
    };

    // Upper bound trace for shading
    const upperTrace = {
      x: trace.x,
      y: high,

      line: { width: 0 },
      marker: { size: 0 },
      showlegend: false,
    };

    // Lower bound trace for shading
    const lowerTrace = {
      x: trace.x,
      y: low,
      fill: 'tonexty', // Fill area between this trace and the previous trace
      fillcolor: color + '33', // Add transparency to the color
      line: { width: 0 },
      marker: { size: 0 },
      showlegend: false,
    };

    return [upperTrace, lowerTrace, mainTrace];
  });

  return (
    <>
      <Card
        size="small"
        title={title}
        extra={<Button type="link" icon={<FullscreenOutlined />} onClick={showModal} />}
      >
        <Plot
          data={updatedData}
          layout={layout}
          useResizeHandler
          style={{ width: '100%', height: '300px' }}
        />
      </Card>

      <Modal
        title={title}
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancel}
        width={'90%'}
      >
        <Plot
          data={updatedData}
          layout={layout}
          useResizeHandler
          style={{ width: '100%', height: '600px' }}
          config={{ displayModeBar: false }}
        />
      </Modal>
    </>
  );
};

export default ChartComponent;
